import "./sales.css";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Chart from "../dashboard/chart/Chart";
import { useGetAllOrderQuery } from "../../services/orderApi";
import { revenueByDay, ordersByStatus, summaryStats } from "../../utils/salesAnalytics";
import { AdminPageHeader, AdminCard, AdminSkeleton } from "../../components/ui";

// Kept in sync with --admin-accent (#5b3ff2) - see Chart.jsx for why this
// can't be a CSS var (recharts renders it as a raw SVG attribute).
const ACCENT = "#5b3ff2";
const GRID = "#edf0f5";

function Sales() {
  const { data: orders, isLoading } = useGetAllOrderQuery();

  return (
    <div className="sales">
      <AdminPageHeader
        title="Sales"
        subtitle="Revenue and order performance."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Sales" }]}
      />
      {isLoading ? (
        <div className="salesStats">
          {Array.from({ length: 4 }).map((_, i) => (
            <AdminCard key={i}>
              <AdminSkeleton variant="text" width="60%" />
              <div style={{ marginTop: 10 }}>
                <AdminSkeleton variant="title" width="50%" />
              </div>
            </AdminCard>
          ))}
        </div>
      ) : (
        <SalesContent orders={orders || []} />
      )}
    </div>
  );
}

function SalesContent({ orders }) {
  const stats = summaryStats(orders);
  const statusData = ordersByStatus(orders);

  return (
    <>
      <div className="salesStats">
        <AdminCard className="salesStatCard">
          <span className="salesStatLabel">Total Revenue</span>
          <span className="salesStatValue">₹ {stats.totalRevenue.toFixed(2)}</span>
        </AdminCard>
        <AdminCard className="salesStatCard">
          <span className="salesStatLabel">Total Orders</span>
          <span className="salesStatValue">{stats.totalOrders}</span>
        </AdminCard>
        <AdminCard className="salesStatCard">
          <span className="salesStatLabel">Average Order Value</span>
          <span className="salesStatValue">₹ {stats.averageOrderValue.toFixed(2)}</span>
        </AdminCard>
        <AdminCard className="salesStatCard">
          <span className="salesStatLabel">Canceled Orders</span>
          <span className="salesStatValue">{stats.canceledCount}</span>
        </AdminCard>
      </div>

      <Chart data={revenueByDay(orders, 30)} title="Revenue (last 30 days)" grid dataKey="Revenue" />

      <AdminCard className="salesStatusChart">
        <h2 className="chartTitle">Orders by Status</h2>
        <ResponsiveContainer width="100%" aspect={4 / 1.5}>
          <BarChart data={statusData}>
            <XAxis dataKey="name" stroke="#8a90a0" fontSize={12} tickLine={false} axisLine={{ stroke: GRID }} />
            <YAxis allowDecimals={false} stroke="#8a90a0" fontSize={12} tickLine={false} axisLine={false} />
            <CartesianGrid stroke={GRID} vertical={false} />
            <Tooltip contentStyle={{ border: "1px solid #edf0f5", borderRadius: 10, fontSize: 13 }} />
            <Bar dataKey="Orders" fill={ACCENT} radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </AdminCard>
    </>
  );
}

export default Sales;
